import { useEffect } from "react";
import "../TestResult/TestResult.scss";
import TrophyIcon from "../../assets/images/vactor/trophy.svg";
import GraphIcon from "../../assets/images/vactor/graph.svg";
import Quadratic from "../../assets/images/vactor/quadratic.svg";
import { LightButton } from "../AllButtons/AllButtons";
import MathRenderer from "../CommonElements/MathRenderer";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { getScores } from "../../Services/mcq.service";
import { useNavigate } from "react-router-dom";
import { useCoursePolling } from "../../hooks/useCoursePolling";

const TestResult = () => {
  let marks=useAppSelector(state=>state.mcq.mcqMarks);

  let marksOnSubmit=useAppSelector(state=>state.mcq.mcqMarksOnGetScore);
  const userId=useAppSelector(state=>state.user.uid);
  const is_course_generated=useAppSelector(state=>state.mcq.course_generated);

  const courseGenerationInProgress = useAppSelector(state => state.course.courseGenerationInProgress);
  const task_id = useAppSelector(state => state.course.task_id);
  const course = useAppSelector(state => state.course.course);

  const isGenerating = courseGenerationInProgress;
  const isAlreadyGenerated = Boolean(is_course_generated);
  const isDisabled = isGenerating || isAlreadyGenerated;

  const finalScore = marks || marksOnSubmit;
  let newScore = 0;

  if (typeof finalScore === 'string') {
    const [score] = finalScore.split('/');
    newScore = parseInt(score, 10);
  } else {
    newScore = finalScore || 0;
  }

  const dispatch=useAppDispatch();
  const navigate = useNavigate(); 

  const {
    handleGenerateCourse,
    handleGenerateIntermediateCourse,
    handleGenerateAdvancedCourse
  } = useCoursePolling(); 

  useEffect(()=>{
    dispatch(getScores(userId));
  },[])

  const generateCourseBasedOnScore = async () => {
    try {
      localStorage.removeItem('taskId');
      localStorage.removeItem('advancetaskid');
      localStorage.removeItem('intermediatetaskid');

      if (newScore <= 4) {
        await handleGenerateCourse(); 
      } else if (newScore >= 5 && newScore <= 7) {    
        await handleGenerateIntermediateCourse();
      } else if (newScore >= 8 && newScore <= 10)  {    
        await handleGenerateAdvancedCourse();
      }

      navigate('/dashboard/course_list');
    } catch (error) {
      console.error("Failed to generate course:", error);
    }
  };

  return (
    <>
      <div className="test-result-wrapper">
        <div className="test-result-header">
          <div className="test-result-header-title">Dashboard</div>
          <div className="test-result-header-subtitle">
          All Your Study Insights in One Place
          </div>
        </div>

        <div className="test-result-card-wrapper">
          <div className="row m-0">
            <div className="col-md-7 d-flex flex-column g-32">
              <div className="result-card">
                <div className="progress-header">
                  <div>
                    <div className="card-title">Last Test Result</div>
                    <div className="card-subtitle">
                    Great things start with knowing where you are.
                    </div>
                  </div>

                  <div className="progress-icon">
                    <img src={TrophyIcon} alt="TrophyIcon" />
                  </div>
                </div>

                <div className="correct-ans-block">
                  <div className="correct-ans-number">{finalScore}</div>
                  <div className="card-subtitle">
                    Questions Answered Correctly
                  </div>
                </div>
              </div>
              <div className="learning-continue">
                <div className="learning-continue-title">
                  {isAlreadyGenerated || isGenerating
                    ? "Continue Learning"
                    : "Ready to Continue?"}
                </div>
                <div className="learning-continue-subtitle">
                  {isGenerating
                    ? "Your personalized course is being generated, please wait..."
                    : isAlreadyGenerated
                      ? "Your course has already been generated."
                      : "The personalized solution has been prepared."}
                </div>
                <LightButton
                  className="start-btn"
                  disabled={isDisabled}
                  style={{
                    cursor: isDisabled ? "not-allowed" : "pointer",
                  }}
                  onClick={() => generateCourseBasedOnScore()}
                >
                  {isGenerating
                    ? "Course Generation in Progress..."
                    : isAlreadyGenerated
                      ? "Course Generated"
                      : "Generate Course Now"}
                </LightButton>
              </div>
            </div>
            <div className="col-md-5 d-flex flex-column g-32">
              {/* <div className="result-card">
                <div className="view-result-block">
                  <div className="card-title">All test results</div>
                  <LightButton className="view-now-btn">View Now</LightButton>
                </div>
              </div> */}

              {/* <div className="result-card">
                <div className="skill-level-block">
                  <div className="proficient-icon">
                    <img src={Proficient} alt="" />
                  </div>
                  <div className="card-title">Skill Level</div>
                  <div className="proficient-text">Proficient</div>
                  <div className="card-subtitle">On Track</div>
                </div>
              </div> */}

              <div className="result-card">
                <div className="card-title">
                  Personalized Learning Suggestions
                </div>
                <div className="row">
                  <div className="suggestion-card">
                    <img src={GraphIcon} alt="" />
                    <div className="card-title">
                      <MathRenderer text="Personalized Learning Suggestions" />
                    </div>
                    <div className="card-subtitle">
                      <MathRenderer text="Focus on solving complex equations with multiple variables" />
                    </div>
                  </div>
                </div>
                <div className="row pt-10">
                  <div className="suggestion-card">
                    <img src={Quadratic} alt="" />
                    <div className="card-title">
                      <MathRenderer text="Quadratic Functions" />
                    </div>
                    <div className="card-subtitle">
                      <MathRenderer text="Practice identifying and solving quadratic equations" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestResult;
